import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { getPreferredUserIdentifier, buildAetUserContext } from '../core/constant/user-context.util';

@Injectable({
  providedIn: 'root',
})
export class ButtonServiceService {
  constructor(private readonly http: HttpClient) {}

  baseURL = environment.baseAPIURL;

  getGridData(user: any) {
    const rb = { event: user, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/aetHistory/getAetHistoryEventsResolutions`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }

  getload(user: any) {
    const rb = { event: user, userReqDto: buildAetUserContext() };
    return this.http.post(`${this.baseURL}/aetHistory/getUserPreference`, rb, { responseType: 'json' }).pipe(catchError(this.handleError));
  }

  getDomicile() {
    return this.http.get(`${this.baseURL}/aetHistory/getAetDomicileItemDesc`, { responseType: 'json' }).pipe(catchError(this.handleError));
  }

  saveload(insertObject: any, toyotaGUID: string): Observable<any> {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
    const rb = { event: insertObject, userReqDto: buildAetUserContext() };
  return this.http.post(`${this.baseURL}/aetHistory/saveUserPreference`, rb, { responseType: 'text' }).pipe(catchError(this.handleError));
  }

  resetload(resetObject: any, toyotaGUID: string): Observable<any> {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
    const rb = { event: resetObject, userReqDto: buildAetUserContext() };
  return this.http.post(this.baseURL + `/aetHistory/resetUserPreference`, rb, { responseType: 'text' }).pipe(catchError(this.handleError));
  }

  loadFilterValues() {
    return this.http.get(`${this.baseURL}/aetDashBoard/filter/onLoad`).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}
